import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ItemSummary from '../components/ItemSummary'
import { withErrorBoundary } from '../errors/ErrorBoundary'
import { landCoverMetadata } from '../config/landCover'

class ItemSummaryContainer extends PureComponent {
  render () {
    const { data } = this.props
    console.log(data)
    if (!data) {
      return null
    }
    console.log('item')

    if (data.value) {
      const { thick_m } = data
      return <ItemSummary  title={'Methane'} value={<span>{`${(data.value/100).toFixed(2)} mol/m`}<sup>2</sup></span>} />
    }

    const whitelist = ['land_cover', 'ndvi', 'rank']

    const items = Object.keys(data)
          .filter(key => whitelist.includes(key))
          .map(key => {
            const title = key
            let value
            if (key === 'land_cover') {
              value = landCoverMetadata.find(item => item.value === data[key]).label
            } else if (key === 'rank') {
              value = data[key].toFixed(2)
            } else if (key === 'ndvi') {
              value = (data[key] / 100).toFixed(2)
            } else {
              value = data[key]
            }
            return <ItemSummary title={title} value={value} key={key}/>
    })

    return items
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    // data: state.data.LeakDetection
    data: state.data[ownProps.id]
  }
}

export default withErrorBoundary(connect(mapStateToProps, null)(ItemSummaryContainer))



// WEBPACK FOOTER //
// ./src/containers/ItemSummaryContainer.js